export default "__VITE_ASSET__OWiSP2B1__"